














import { Component, Vue } from 'vue-property-decorator';
import NewsApiAgent,{ News } from '../services/news-api-agent';
import BbParserService from '../services/bb-parser.service';

// @ts-ignore
@Component
// @ts-ignore
export default class Home extends Vue {

  constructor(private newsApiAgent = NewsApiAgent, private bbParserService = BbParserService) {
    super();
  }

  private news: any[] = [];

  mounted () {
    this.newsApiAgent.getAll().then(news => {
      this.news = news.map(n => {
        return {
          date: new Date(n.datum * 1000).toLocaleString(),
          title: n.title,
          content: this.bbParserService.fromBb(n.content)
        };
      });
    });
  }
}
